import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, where, doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useLang, LangToggle } from '../LanguageContext';
import { t } from '../i18n';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// ─── MODAL APERÇU ─────────────────────────────────────────────────────────────
function ModalApercu({ data, onClose, onDownload }) {
  if (!data) return null;
  return (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.box} onClick={e => e.stopPropagation()}>
        <div style={modalStyles.header}>
          <div style={modalStyles.headerTitle}>📄 Aperçu PDF — Fiche Commercial</div>
          <button style={modalStyles.closeBtn} onClick={onClose}>✕</button>
        </div>
        <div style={modalStyles.body}>

          {/* EN-TÊTE */}
          <div style={modalStyles.ficheHeader}>
            <div style={modalStyles.ficheAvatar}>{(data.prenom || 'C')[0]}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>{data.prenom} {data.nom}</div>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)', marginTop: 2 }}>{data.wilayas}</div>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginTop: 2 }}>{data.dateStr} · {data.moisNom}</div>
            </div>
            <div style={{ ...modalStyles.scoreBadge, background: data.score >= 80 ? '#3B6D11' : data.score >= 50 ? '#854F0B' : '#C0392B' }}>
              <div style={{ fontSize: 20, fontWeight: 700, color: '#fff' }}>{data.score}%</div>
              <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.7)' }}>score</div>
            </div>
          </div>

          {/* KPIs */}
          <div style={modalStyles.kpiRow}>
            {data.kpis.map((k, i) => (
              <div key={i} style={{ ...modalStyles.kpiBox, color: k.color }}>
                <div style={modalStyles.kpiVal}>{k.val}</div>
                <div style={modalStyles.kpiLabel}>{k.label}</div>
              </div>
            ))}
          </div>

          {/* PRIME */}
          <div style={modalStyles.primeBox}>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)' }}>Prime estimée</div>
            <div style={{ fontSize: 22, fontWeight: 700, color: '#fff', margin: '4px 0' }}>{data.primeEstimee.toLocaleString()} DA</div>
            <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)' }}>Base : {data.varTotal.toLocaleString()} DA · Score : {data.score}%</div>
          </div>

          {/* VISITES */}
          {data.visitesMois.length > 0 && (
            <div style={modalStyles.tableWrap}>
              <div style={modalStyles.tableTitle}>Visites du mois ({data.visitesMois.length})</div>
              <table style={modalStyles.table}>
                <thead>
                  <tr style={modalStyles.thead}>
                    {['Date', 'Client', 'Résultat'].map(h => <th key={h} style={modalStyles.th}>{h}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {data.visitesMois.slice(0, 8).map((v, i) => (
                    <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#f8f8f8' }}>
                      <td style={modalStyles.td}>{v.heureDebut ? new Date(v.heureDebut).toLocaleDateString('fr-FR') : '—'}</td>
                      <td style={modalStyles.td}>{v.clientNom || '—'}</td>
                      <td style={modalStyles.td}>{v.resultat || '—'}</td>
                    </tr>
                  ))}
                  {data.visitesMois.length > 8 && (
                    <tr><td colSpan={3} style={{ textAlign: 'center', padding: 6, fontSize: 11, color: '#888' }}>+ {data.visitesMois.length - 8} autres visites dans le PDF</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          {/* CLIENTS */}
          {data.clients.length > 0 && (
            <div style={modalStyles.tableWrap}>
              <div style={modalStyles.tableTitle}>Clients assignés ({data.clients.length})</div>
              <table style={modalStyles.table}>
                <thead>
                  <tr style={modalStyles.thead}>
                    {['Client', 'Commune', 'Potentiel'].map(h => <th key={h} style={modalStyles.th}>{h}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {data.clients.slice(0, 6).map((c, i) => (
                    <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#f8f8f8' }}>
                      <td style={modalStyles.td}>{c.nom || '—'}</td>
                      <td style={modalStyles.td}>{c.commune || '—'}</td>
                      <td style={{ ...modalStyles.td, color: c.potentiel === 'Fort' ? '#3B6D11' : c.potentiel === 'Faible' ? '#C0392B' : '#854F0B', fontWeight: 600 }}>{c.potentiel || 'Moyen'}</td>
                    </tr>
                  ))}
                  {data.clients.length > 6 && (
                    <tr><td colSpan={3} style={{ textAlign: 'center', padding: 6, fontSize: 11, color: '#888' }}>+ {data.clients.length - 6} autres dans le PDF</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          {/* RETARDS */}
          {data.actionsRetard.length > 0 && (
            <div style={{ background: '#FCEBEB', borderRadius: 8, padding: '10px 12px' }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: '#A32D2D', marginBottom: 6 }}>⚠ Actions en retard ({data.actionsRetard.length})</div>
              {data.actionsRetard.slice(0, 3).map((a, i) => (
                <div key={i} style={{ fontSize: 12, color: '#A32D2D', marginBottom: 3 }}>• {a.clientNom} — {a.action} ({a.dateAction})</div>
              ))}
            </div>
          )}

        </div>
        <div style={modalStyles.footer}>
          <button style={modalStyles.btnCancel} onClick={onClose}>✕ Fermer</button>
          <button style={modalStyles.btnDownload} onClick={onDownload}>⬇ Télécharger PDF</button>
        </div>
      </div>
    </div>
  );
}

const modalStyles = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 1000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' },
  box: { background: '#fff', borderRadius: '16px 16px 0 0', width: '100%', maxWidth: 480, maxHeight: '90vh', display: 'flex', flexDirection: 'column' },
  header: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px', borderBottom: '1px solid #eee', flexShrink: 0 },
  headerTitle: { fontSize: 14, fontWeight: 700, color: '#1C2833' },
  closeBtn: { background: '#f0f0f0', border: 'none', borderRadius: '50%', width: 28, height: 28, fontSize: 13, cursor: 'pointer', color: '#555' },
  body: { overflowY: 'auto', padding: '14px 16px', flex: 1, display: 'flex', flexDirection: 'column', gap: 12 },
  ficheHeader: { background: '#1C2833', borderRadius: 10, padding: '14px', display: 'flex', alignItems: 'center', gap: 12 },
  ficheAvatar: { width: 42, height: 42, borderRadius: '50%', background: 'rgba(255,255,255,0.15)', color: '#fff', fontSize: 18, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  scoreBadge: { borderRadius: 8, padding: '6px 10px', textAlign: 'center', flexShrink: 0 },
  kpiRow: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 6 },
  kpiBox: { background: '#f5f5f5', borderRadius: 8, padding: '8px 4px', textAlign: 'center' },
  kpiVal: { fontSize: 16, fontWeight: 700 },
  kpiLabel: { fontSize: 9, color: '#888', marginTop: 2, lineHeight: 1.3 },
  primeBox: { background: '#1C2833', borderRadius: 10, padding: '14px', textAlign: 'center' },
  tableWrap: { display: 'flex', flexDirection: 'column', gap: 6 },
  tableTitle: { fontSize: 11, fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: 0.5 },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 11 },
  thead: { background: '#1C2833' },
  th: { padding: '6px 8px', color: '#fff', textAlign: 'left', fontWeight: 600, fontSize: 10 },
  td: { padding: '6px 8px', borderBottom: '1px solid #f0f0f0', color: '#1C2833' },
  footer: { display: 'flex', gap: 8, padding: '12px 16px', borderTop: '1px solid #eee', flexShrink: 0 },
  btnCancel: { flex: 1, padding: '11px', border: '1px solid #ddd', borderRadius: 10, background: '#fff', color: '#666', fontSize: 13, cursor: 'pointer' },
  btnDownload: { flex: 2, padding: '11px', background: '#1C2833', border: 'none', borderRadius: 10, color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer' },
};
// ─────────────────────────────────────────────────────────────────────────────

export default function FicheCommercial({ commercial, onClose }) {
  const [visites, setVisites] = useState([]);
  const [actions, setActions] = useState([]);
  const [clients, setClients] = useState([]);
  const [assignation, setAssignation] = useState(null);
  const [objectifs, setObjectifs] = useState([]);
  const [plannings, setPlannings] = useState([]);
  const [onglet, setOnglet] = useState('kpis');
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const { lang, isRTL } = useLang();
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({
    objectifVisites: commercial.objectifVisites || 60,
    objectifClients: commercial.objectifClients || 3,
    variableTotal: commercial.variableTotal || 0,
    wilayas: (commercial.wilayas || []).join(', '),
  });

  useEffect(() => { charger(); }, []);

  const charger = async () => {
    setLoading(true);
    try {
      const vSnap = await getDocs(query(collection(db, 'visites'), where('commercialId', '==', commercial.id)));
      setVisites(vSnap.docs.map(d => ({ id: d.id, ...d.data() })).sort((a, b) => new Date(b.heureDebut || 0) - new Date(a.heureDebut || 0)));
      const aSnap = await getDocs(query(collection(db, 'actions'), where('commercialId', '==', commercial.id)));
      setActions(aSnap.docs.map(d => ({ id: d.id, ...d.data() })));
      const cSnap = await getDocs(query(collection(db, 'clients'), where('commercialIds', 'array-contains', commercial.id)));
      setClients(cSnap.docs.map(d => ({ id: d.id, ...d.data() })));
      const asSnap = await getDocs(query(collection(db, 'assignations'), where('commercialId', '==', commercial.id)));
      if (asSnap.docs.length > 0) setAssignation({ id: asSnap.docs[0].id, ...asSnap.docs[0].data() });
      const oSnap = await getDocs(collection(db, 'objectifs'));
      setObjectifs(oSnap.docs.map(d => ({ id: d.id, ...d.data() })));
      const pSnap = await getDocs(query(collection(db, 'plannings'), where('commercialId', '==', commercial.id)));
      setPlannings(pSnap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (e) { console.log(e); }
    setLoading(false);
  };

  const sauvegarder = async () => {
    try {
      await updateDoc(doc(db, 'users', commercial.id), {
        objectifVisites: parseInt(form.objectifVisites),
        objectifClients: parseInt(form.objectifClients),
        variableTotal: parseInt(form.variableTotal),
        wilayas: form.wilayas.split(',').map(w => w.trim()).filter(w => w),
      });
      setEditMode(false);
    } catch (e) { alert('Erreur: ' + e.message); }
  };

  const maintenant = new Date();
  const debutMois = new Date(maintenant.getFullYear(), maintenant.getMonth(), 1);
  const visitesMois = visites.filter(v => v.heureDebut && new Date(v.heureDebut) >= debutMois);
  const actionsRetard = actions.filter(a => a.statut === 'A FAIRE' && a.dateAction && new Date(a.dateAction) < maintenant);
  const actionsFaites = actions.filter(a => a.statut === 'FAIT');
  const score = Math.round((visitesMois.length / Math.max(commercial.objectifVisites || 60, 1)) * 100);
  const varTotal = assignation?.variableTotal || commercial.variableTotal || 0;
  const primeEstimee = Math.round(varTotal * Math.min(score, 100) / 100);

  const resultatsMap = {};
  visitesMois.forEach(v => { const r = v.resultat || 'Non renseigné'; resultatsMap[r] = (resultatsMap[r] || 0) + 1; });

  const visitesParJour = [];
  for (let i = 6; i >= 0; i--) {
    const d = new Date(); d.setDate(d.getDate() - i);
    const count = visites.filter(v => v.heureDebut && new Date(v.heureDebut).toDateString() === d.toDateString()).length;
    visitesParJour.push({ label: d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric' }), count });
  }
  const maxV = Math.max(...visitesParJour.map(v => v.count), 1);

  const COLORS = ['#C0392B', '#185FA5', '#3B6D11', '#854F0B', '#1D9E75'];
  const moisNom = maintenant.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
  const dateStr = maintenant.toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' });
  const nomComplet = `${commercial.prenom || ''} ${commercial.nom || ''}`.trim();

  // ── OUVRIR APERÇU ──
  const ouvrirApercu = () => {
    setModal({
      prenom: commercial.prenom,
      nom: commercial.nom,
      wilayas: (commercial.wilayas || []).join(' · ') || '—',
      dateStr,
      moisNom,
      score,
      primeEstimee,
      varTotal,
      kpis: [
        { val: `${visitesMois.length}/${commercial.objectifVisites || 60}`, label: 'Visites ce mois', color: '#1C2833' },
        { val: clients.filter(c => c.statut === 'Nouveau client').length, label: 'Nouveaux clients', color: '#185FA5' },
        { val: actionsRetard.length, label: 'Actions en retard', color: '#C0392B' },
        { val: actionsFaites.length, label: 'Actions faites', color: '#3B6D11' },
      ],
      visitesMois,
      clients,
      actionsRetard,
    });
  };

  // ── TÉLÉCHARGER PDF ──
  const telechargerPDF = () => {
    try {
      const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
      const pageW = doc.internal.pageSize.getWidth();

      doc.setFillColor(28, 40, 51);
      doc.rect(0, 0, pageW, 32, 'F');
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(16);
      doc.setFont('helvetica', 'bold');
      doc.text(`Fiche Commercial — ${nomComplet}`, 14, 12);
      doc.setFontSize(9);
      doc.setFont('helvetica', 'normal');
      doc.text(`KDPeinture · Généré le ${dateStr}`, 14, 20);
      doc.text(`Période : ${moisNom}  ·  Wilayas : ${(commercial.wilayas || []).join(', ') || '—'}`, 14, 27);

      const scoreColor = score >= 80 ? [59, 109, 17] : score >= 50 ? [133, 79, 11] : [192, 57, 43];
      doc.setFillColor(...scoreColor);
      doc.roundedRect(pageW - 40, 8, 28, 18, 3, 3, 'F');
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(16);
      doc.setFont('helvetica', 'bold');
      doc.text(`${score}%`, pageW - 26, 20, { align: 'center' });
      doc.setFontSize(7);
      doc.setFont('helvetica', 'normal');
      doc.text('score mois', pageW - 26, 25, { align: 'center' });

      let y = 40;

      doc.setTextColor(136, 136, 136);
      doc.setFontSize(8);
      doc.setFont('helvetica', 'bold');
      doc.text('INDICATEURS DU MOIS', 14, y);
      y += 5;

      const kpis = [
        { label: 'Visites ce mois', val: `${visitesMois.length}/${commercial.objectifVisites || 60}`, color: [28, 40, 51] },
        { label: 'Nouveaux clients', val: clients.filter(c => c.statut === 'Nouveau client').length, color: [24, 95, 165] },
        { label: 'Actions en retard', val: actionsRetard.length, color: [192, 57, 43] },
        { label: 'Actions faites', val: actionsFaites.length, color: [59, 109, 17] },
      ];
      const kpiW = (pageW - 28) / 4;
      kpis.forEach((k, i) => {
        const x = 14 + i * kpiW;
        doc.setFillColor(245, 245, 245);
        doc.roundedRect(x, y, kpiW - 3, 18, 2, 2, 'F');
        doc.setTextColor(...k.color);
        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text(String(k.val), x + (kpiW - 3) / 2, y + 9, { align: 'center' });
        doc.setFontSize(7);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(120, 120, 120);
        doc.text(k.label, x + (kpiW - 3) / 2, y + 15, { align: 'center' });
      });
      y += 25;

      doc.setFillColor(28, 40, 51);
      doc.roundedRect(14, y, pageW - 28, 18, 3, 3, 'F');
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.text(`Prime estimée : ${primeEstimee.toLocaleString('fr-FR')} DA`, 20, y + 7);
      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(180, 220, 180);
      doc.text(`Base variable : ${varTotal.toLocaleString('fr-FR')} DA  ·  Score : ${score}%`, 20, y + 14);
      y += 25;

      doc.setTextColor(136, 136, 136);
      doc.setFontSize(8);
      doc.setFont('helvetica', 'bold');
      doc.text('VISITES — 7 DERNIERS JOURS', 14, y);
      y += 4;
      autoTable(doc, {
        startY: y,
        head: [visitesParJour.map(v => v.label)],
        body: [visitesParJour.map(v => v.count)],
        styles: { fontSize: 9, cellPadding: 3, halign: 'center' },
        headStyles: { fillColor: [240, 240, 240], textColor: [100, 100, 100], fontStyle: 'normal', fontSize: 8 },
        bodyStyles: { fontStyle: 'bold', textColor: [28, 40, 51] },
        margin: { left: 14, right: 14 },
      });
      y = doc.lastAutoTable.finalY + 10;

      if (Object.keys(resultatsMap).length > 0) {
        if (y > 220) { doc.addPage(); y = 20; }
        doc.setTextColor(136, 136, 136);
        doc.setFontSize(8);
        doc.setFont('helvetica', 'bold');
        doc.text('RÉSULTATS DES VISITES (CE MOIS)', 14, y);
        y += 4;
        autoTable(doc, {
          startY: y,
          head: [['Résultat', 'Nombre', 'Part (%)']],
          body: Object.entries(resultatsMap).sort((a, b) => b[1] - a[1]).map(([r, count]) => [r, count, `${Math.round((count / Math.max(visitesMois.length, 1)) * 100)}%`]),
          styles: { fontSize: 9, cellPadding: 3 },
          headStyles: { fillColor: [28, 40, 51], textColor: 255, fontStyle: 'bold', fontSize: 8 },
          columnStyles: { 0: { cellWidth: 100 }, 1: { halign: 'center' }, 2: { halign: 'center' } },
          alternateRowStyles: { fillColor: [248, 248, 248] },
          margin: { left: 14, right: 14 },
        });
        y = doc.lastAutoTable.finalY + 10;
      }

      if (visitesMois.length > 0) {
        if (y > 200) { doc.addPage(); y = 20; }
        doc.setTextColor(136, 136, 136);
        doc.setFontSize(8);
        doc.setFont('helvetica', 'bold');
        doc.text(`VISITES DU MOIS (${visitesMois.length})`, 14, y);
        y += 4;
        autoTable(doc, {
          startY: y,
          head: [['Date', 'Client', 'Résultat', 'Commentaire']],
          body: visitesMois.slice(0, 30).map(v => [
            v.heureDebut ? new Date(v.heureDebut).toLocaleDateString('fr-FR') : '—',
            v.clientNom || '—', v.resultat || '—',
            v.commentaire ? v.commentaire.substring(0, 40) + (v.commentaire.length > 40 ? '…' : '') : '—',
          ]),
          styles: { fontSize: 8, cellPadding: 2.5 },
          headStyles: { fillColor: [28, 40, 51], textColor: 255, fontStyle: 'bold', fontSize: 8 },
          columnStyles: { 0: { cellWidth: 22 }, 1: { cellWidth: 40 }, 2: { cellWidth: 40 }, 3: { cellWidth: 'auto' } },
          alternateRowStyles: { fillColor: [248, 248, 248] },
          margin: { left: 14, right: 14 },
        });
        y = doc.lastAutoTable.finalY + 10;
      }

      if (clients.length > 0) {
        if (y > 200) { doc.addPage(); y = 20; }
        doc.setTextColor(136, 136, 136);
        doc.setFontSize(8);
        doc.setFont('helvetica', 'bold');
        doc.text(`CLIENTS ASSIGNÉS (${clients.length})`, 14, y);
        y += 4;
        autoTable(doc, {
          startY: y,
          head: [['Client', 'Type / Statut', 'Commune', 'Potentiel', 'Visites']],
          body: clients.map(c => [c.nom || '—', c.type || c.statut || '—', c.commune || '—', c.potentiel || 'Moyen', visites.filter(v => v.clientId === c.id).length]),
          styles: { fontSize: 8, cellPadding: 2.5 },
          headStyles: { fillColor: [28, 40, 51], textColor: 255, fontStyle: 'bold', fontSize: 8 },
          columnStyles: { 3: { halign: 'center' }, 4: { halign: 'center' } },
          alternateRowStyles: { fillColor: [248, 248, 248] },
          margin: { left: 14, right: 14 },
        });
        y = doc.lastAutoTable.finalY + 10;
      }

      if (actionsRetard.length > 0) {
        if (y > 220) { doc.addPage(); y = 20; }
        doc.setTextColor(192, 57, 43);
        doc.setFontSize(8);
        doc.setFont('helvetica', 'bold');
        doc.text(`⚠ ACTIONS EN RETARD (${actionsRetard.length})`, 14, y);
        y += 4;
        autoTable(doc, {
          startY: y,
          head: [['Client', 'Action', 'Date prévue']],
          body: actionsRetard.map(a => [a.clientNom || '—', a.action || '—', a.dateAction || '—']),
          styles: { fontSize: 8, cellPadding: 2.5 },
          headStyles: { fillColor: [192, 57, 43], textColor: 255, fontStyle: 'bold', fontSize: 8 },
          bodyStyles: { textColor: [150, 30, 30] },
          alternateRowStyles: { fillColor: [253, 240, 240] },
          margin: { left: 14, right: 14 },
        });
        y = doc.lastAutoTable.finalY + 10;
      }

      if (assignation && objectifs.length > 0) {
        const objActifs = objectifs.filter(o => assignation.objectifsRatios?.[o.id]);
        if (objActifs.length > 0) {
          if (y > 220) { doc.addPage(); y = 20; }
          doc.setTextColor(136, 136, 136);
          doc.setFontSize(8);
          doc.setFont('helvetica', 'bold');
          doc.text('DÉTAIL PRIME PAR OBJECTIF', 14, y);
          y += 4;
          autoTable(doc, {
            startY: y,
            head: [['Objectif', 'Cible', 'Ratio', 'Montant DA']],
            body: objActifs.map(o => {
              const ratio = assignation.objectifsRatios[o.id];
              return [o.designation || '—', `${o.objectif} ${o.unite} ${o.periode}`, `${ratio}%`, `${Math.round(varTotal * ratio / 100).toLocaleString('fr-FR')} DA`];
            }),
            styles: { fontSize: 8, cellPadding: 2.5 },
            headStyles: { fillColor: [28, 40, 51], textColor: 255, fontStyle: 'bold', fontSize: 8 },
            columnStyles: { 2: { halign: 'center' }, 3: { halign: 'right', fontStyle: 'bold', textColor: [59, 109, 17] } },
            alternateRowStyles: { fillColor: [248, 248, 248] },
            margin: { left: 14, right: 14 },
          });
        }
      }

      const totalPages = doc.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.setFontSize(7);
        doc.setTextColor(180, 180, 180);
        doc.text(`KDPeinture · Fiche ${nomComplet} · ${dateStr} · Page ${i}/${totalPages}`, pageW / 2, doc.internal.pageSize.getHeight() - 8, { align: 'center' });
      }

      doc.save(`fiche-${nomComplet.replace(/ /g, '-').toLowerCase()}-${maintenant.toLocaleDateString('fr-FR').replace(/\//g, '-')}.pdf`);
    } catch (err) {
      console.error('Erreur PDF:', err);
      alert('Erreur lors de la génération du PDF.');
    }
    setModal(null);
  };

  return (
    <div style={styles.app}>
      {modal && <ModalApercu data={modal} onClose={() => setModal(null)} onDownload={telechargerPDF} />}

      <div style={styles.topbar}>
        <button onClick={onClose} style={styles.backBtn}>←</button>
        <div style={{ flex: 1 }}>
          <div style={styles.topbarTitle}>{commercial.prenom} {commercial.nom}</div>
          <div style={styles.topbarSub}>Commercial · {moisNom}</div>
        </div>
        <button style={{ ...styles.editBtn, background: 'rgba(192,57,43,0.85)', fontSize: 12, width: 'auto', padding: '0 10px' }} onClick={ouvrirApercu}>
          📄 PDF
        </button>
        <button style={styles.editBtn} onClick={() => setEditMode(!editMode)}>
          {editMode ? '✕' : '✎'}
        </button>
      </div>

      <div style={styles.profileBar}>
        <div style={styles.avatar}>{(commercial.prenom || 'C')[0].toUpperCase()}</div>
        <div style={{ flex: 1 }}>
          <div style={styles.profileName}>{commercial.prenom} {commercial.nom}</div>
          <div style={styles.profileSub}>{(commercial.wilayas || []).join(' · ')}</div>
          <div style={{ display: 'flex', gap: 6, marginTop: 6 }}>
            <span style={{ ...styles.badge, background: '#EAF3DE', color: '#3B6D11' }}>{clients.length} clients</span>
            <span style={{ ...styles.badge, background: '#E6F1FB', color: '#185FA5' }}>{visites.length} visites total</span>
            {actionsRetard.length > 0 && <span style={{ ...styles.badge, background: '#FCEBEB', color: '#A32D2D' }}>{actionsRetard.length} retards</span>}
          </div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: 28, fontWeight: 700, color: score >= 80 ? '#3B6D11' : score >= 50 ? '#854F0B' : '#C0392B' }}>{score}%</div>
          <div style={{ fontSize: 10, color: '#888' }}>score mois</div>
        </div>
      </div>

      <div style={styles.tabs}>
        {[
          { id: 'kpis', label: 'KPIs' },
          { id: 'visites', label: `Visites (${visitesMois.length})` },
          { id: 'clients', label: `Clients (${clients.length})` },
          { id: 'actions', label: `Actions (${actions.length})` },
          { id: 'prime', label: 'Prime' },
        ].map(t => (
          <div key={t.id} style={{ ...styles.tab, ...(onglet === t.id ? styles.tabActive : {}) }} onClick={() => setOnglet(t.id)}>
            {t.label}
          </div>
        ))}
      </div>

      <div style={styles.content}>
        {onglet === 'kpis' && (
          <>
            {editMode ? (
              <div style={styles.editCard}>
                <div style={styles.sectionLabel}>Modifier les objectifs</div>
                {[
                  { label: 'Objectif visites / mois', key: 'objectifVisites' },
                  { label: 'Objectif nouveaux clients / mois', key: 'objectifClients' },
                  { label: 'Variable total (DA / mois)', key: 'variableTotal' },
                  { label: 'Wilayas (séparées par virgule)', key: 'wilayas' },
                ].map(f => (
                  <div key={f.key} style={{ marginBottom: 10 }}>
                    <div style={styles.fieldLabel}>{f.label}</div>
                    <input style={styles.input} value={form[f.key]} type={f.key === 'wilayas' ? 'text' : 'number'}
                      onChange={e => setForm(x => ({ ...x, [f.key]: e.target.value }))} />
                  </div>
                ))}
                <div style={{ display: 'flex', gap: 8 }}>
                  <button style={styles.btnCancel} onClick={() => setEditMode(false)}>Annuler</button>
                  <button style={styles.btnSave} onClick={sauvegarder}>✅ Sauvegarder</button>
                </div>
              </div>
            ) : (
              <>
                <div style={styles.statsGrid}>
                  {[
                    { val: visitesMois.length, max: commercial.objectifVisites || 60, label: 'Visites ce mois', color: '#1C2833' },
                    { val: clients.filter(c => c.statut === 'Nouveau client').length, max: commercial.objectifClients || 3, label: 'Nouveaux clients', color: '#185FA5' },
                    { val: actionsRetard.length, max: null, label: 'Actions en retard', color: '#C0392B' },
                    { val: actionsFaites.length, max: null, label: 'Actions faites', color: '#3B6D11' },
                  ].map((s, i) => (
                    <div key={i} style={styles.statCard}>
                      <div style={{ ...styles.statVal, color: s.color }}>{s.val}{s.max ? `/${s.max}` : ''}</div>
                      <div style={styles.statLabel}>{s.label}</div>
                    </div>
                  ))}
                </div>
                <div style={styles.sectionLabel}>Visites — 7 derniers jours</div>
                <div style={styles.graphCard}>
                  <div style={styles.barChart}>
                    {visitesParJour.map((v, i) => (
                      <div key={i} style={styles.barItem}>
                        <div style={styles.barWrap}>
                          <div style={{ ...styles.bar, height: `${Math.round((v.count / maxV) * 100)}%`, background: v.count > 0 ? '#1C2833' : '#e0e0e0' }}>
                            {v.count > 0 && <div style={styles.barVal}>{v.count}</div>}
                          </div>
                        </div>
                        <div style={styles.barLabel}>{v.label}</div>
                      </div>
                    ))}
                  </div>
                </div>
                {Object.keys(resultatsMap).length > 0 && (
                  <>
                    <div style={styles.sectionLabel}>Résultats des visites</div>
                    <div style={styles.resultatCard}>
                      {Object.entries(resultatsMap).sort((a, b) => b[1] - a[1]).map(([r, count], i) => (
                        <div key={i} style={styles.resultatRow}>
                          <div style={{ ...styles.resultatDot, background: COLORS[i % COLORS.length] }}></div>
                          <div style={{ flex: 1, fontSize: 12, color: '#1C2833' }}>{r}</div>
                          <div style={{ fontSize: 12, fontWeight: 600, marginRight: 8 }}>{count}</div>
                          <div style={styles.resultatBarWrap}>
                            <div style={{ ...styles.resultatBar, width: `${Math.round((count / visitesMois.length) * 100)}%`, background: COLORS[i % COLORS.length] }}></div>
                          </div>
                          <div style={{ fontSize: 10, color: '#888', minWidth: 28 }}>{Math.round((count / visitesMois.length) * 100)}%</div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </>
            )}
          </>
        )}

        {onglet === 'visites' && (
          <>
            {visitesMois.length === 0 && <div style={styles.empty}><div style={{ fontSize: 32 }}>📋</div><div style={{ color: '#888', marginTop: 8 }}>Aucune visite ce mois</div></div>}
            {visitesMois.map((v, i) => (
              <div key={v.id} style={styles.visiteCard}>
                <div style={styles.visiteDateBadge}>{v.heureDebut ? new Date(v.heureDebut).toLocaleDateString('fr-FR') : ''}</div>
                <div style={{ flex: 1 }}>
                  <div style={styles.visiteClient}>{v.clientNom}</div>
                  <div style={styles.visiteResultat}>{v.resultat}</div>
                  {v.commentaire && <div style={styles.visiteComment}>💬 {v.commentaire}</div>}
                  {v.prochaineAction && <div style={{ fontSize: 11, color: '#185FA5', marginTop: 3 }}>→ {v.prochaineAction}</div>}
                </div>
              </div>
            ))}
          </>
        )}

        {onglet === 'clients' && (
          <>
            {clients.length === 0 && <div style={styles.empty}><div style={{ fontSize: 32 }}>👥</div><div style={{ color: '#888', marginTop: 8 }}>Aucun client assigné</div></div>}
            {clients.map((c, i) => {
              const nbVisites = visites.filter(v => v.clientId === c.id).length;
              return (
                <div key={c.id} style={styles.clientCard}>
                  <div style={styles.clientAv}>{c.nom?.[0]?.toUpperCase()}</div>
                  <div style={{ flex: 1 }}>
                    <div style={styles.clientNom}>{c.nom}</div>
                    <div style={styles.clientSub}>{c.type || c.statut} · {c.commune} · {nbVisites} visite(s)</div>
                  </div>
                  <div style={{ ...styles.potBadge, background: c.potentiel === 'Fort' ? '#EAF3DE' : c.potentiel === 'Faible' ? '#FCEBEB' : '#FAEEDA', color: c.potentiel === 'Fort' ? '#3B6D11' : c.potentiel === 'Faible' ? '#A32D2D' : '#854F0B' }}>
                    {c.potentiel || 'Moyen'}
                  </div>
                </div>
              );
            })}
          </>
        )}

        {onglet === 'actions' && (
          <>
            {actions.length === 0 && <div style={styles.empty}><div style={{ fontSize: 32 }}>✅</div><div style={{ color: '#888', marginTop: 8 }}>Aucune action</div></div>}
            {actionsRetard.length > 0 && <div style={styles.sectionLabel}>⚠️ En retard ({actionsRetard.length})</div>}
            {actionsRetard.map((a, i) => (
              <div key={a.id} style={{ ...styles.actionCard, background: '#FCEBEB' }}>
                <div style={{ fontSize: 18 }}>⚠️</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#A32D2D' }}>{a.clientNom}</div>
                  <div style={{ fontSize: 12, color: '#A32D2D' }}>{a.action} · {a.dateAction}</div>
                </div>
              </div>
            ))}
            {actions.filter(a => a.statut === 'A FAIRE' && !(a.dateAction && new Date(a.dateAction) < maintenant)).length > 0 && (
              <div style={styles.sectionLabel}>📅 À venir</div>
            )}
            {actions.filter(a => a.statut === 'A FAIRE' && !(a.dateAction && new Date(a.dateAction) < maintenant)).map((a, i) => (
              <div key={a.id} style={{ ...styles.actionCard, background: '#EAF3DE' }}>
                <div style={{ fontSize: 18 }}>📅</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#3B6D11' }}>{a.clientNom}</div>
                  <div style={{ fontSize: 12, color: '#3B6D11' }}>{a.action} · {a.dateAction}</div>
                </div>
              </div>
            ))}
          </>
        )}

        {onglet === 'prime' && (
          <>
            <div style={styles.primeCard}>
              <div style={styles.primeTitre}>Prime estimée — {moisNom}</div>
              <div style={styles.primeMontant}>{primeEstimee.toLocaleString()} DA</div>
              <div style={styles.primeBase}>Base : {varTotal.toLocaleString()} DA · Score : {score}%</div>
              <div style={styles.primeBar}><div style={{ ...styles.primeBarFill, width: `${Math.min(score, 100)}%` }}></div></div>
            </div>
            {assignation && objectifs.length > 0 && (
              <>
                <div style={styles.sectionLabel}>Détail par objectif</div>
                {objectifs.map((o, i) => {
                  const ratio = assignation.objectifsRatios?.[o.id] || 0;
                  if (!ratio) return null;
                  const montant = Math.round(varTotal * ratio / 100);
                  return (
                    <div key={o.id} style={styles.objRow}>
                      <div style={{ ...styles.objDot, background: COLORS[i % COLORS.length] }}></div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 13, fontWeight: 500, color: '#1C2833' }}>{o.designation}</div>
                        <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>{o.objectif} {o.unite} {o.periode}</div>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: 13, fontWeight: 600, color: COLORS[i % COLORS.length] }}>{ratio}%</div>
                        <div style={{ fontSize: 11, color: '#888' }}>{montant.toLocaleString()} DA</div>
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  app: { maxWidth: 480, margin: '0 auto', minHeight: '100vh', background: '#f5f5f5', display: 'flex', flexDirection: 'column', fontFamily: 'system-ui, sans-serif' },
  topbar: { background: '#1C2833', padding: '1rem 1.25rem', color: '#fff', display: 'flex', alignItems: 'center', gap: 8 },
  backBtn: { background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: '50%', width: 32, height: 32, color: '#fff', fontSize: 16, cursor: 'pointer', flexShrink: 0 },
  topbarTitle: { fontSize: 15, fontWeight: 600 },
  topbarSub: { fontSize: 11, opacity: 0.7, marginTop: 2 },
  editBtn: { background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: 8, color: '#fff', fontSize: 16, width: 32, height: 32, cursor: 'pointer', flexShrink: 0 },
  profileBar: { background: '#fff', padding: '14px', display: 'flex', alignItems: 'center', gap: 12, borderBottom: '1px solid #eee' },
  avatar: { width: 48, height: 48, borderRadius: '50%', background: '#1C2833', color: '#fff', fontSize: 20, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  profileName: { fontSize: 14, fontWeight: 700, color: '#1C2833' },
  profileSub: { fontSize: 11, color: '#888', marginTop: 2 },
  badge: { fontSize: 10, padding: '2px 8px', borderRadius: 99, fontWeight: 500 },
  tabs: { display: 'flex', background: '#fff', borderBottom: '1px solid #eee', overflowX: 'auto' },
  tab: { padding: '10px 12px', fontSize: 12, color: '#888', cursor: 'pointer', borderBottom: '2px solid transparent', whiteSpace: 'nowrap', flexShrink: 0 },
  tabActive: { color: '#1C2833', borderBottomColor: '#1C2833', fontWeight: 600 },
  content: { flex: 1, overflowY: 'auto', padding: '12px', display: 'flex', flexDirection: 'column', gap: 10 },
  sectionLabel: { fontSize: 11, fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: 0.5 },
  statsGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 6 },
  statCard: { background: '#fff', borderRadius: 10, padding: '10px 6px', textAlign: 'center', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' },
  statVal: { fontSize: 16, fontWeight: 700 },
  statLabel: { fontSize: 9, color: '#888', marginTop: 2, lineHeight: 1.3 },
  graphCard: { background: '#fff', borderRadius: 10, padding: '14px 12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' },
  barChart: { display: 'flex', gap: 6, alignItems: 'flex-end', height: 70 },
  barItem: { flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 },
  barWrap: { width: '100%', height: 50, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' },
  bar: { width: '100%', borderRadius: '4px 4px 0 0', position: 'relative', minHeight: 4 },
  barVal: { position: 'absolute', top: -16, left: '50%', transform: 'translateX(-50%)', fontSize: 10, fontWeight: 600, color: '#1C2833' },
  barLabel: { fontSize: 9, color: '#888' },
  resultatCard: { background: '#fff', borderRadius: 10, padding: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', display: 'flex', flexDirection: 'column', gap: 8 },
  resultatRow: { display: 'flex', alignItems: 'center', gap: 6 },
  resultatDot: { width: 8, height: 8, borderRadius: '50%', flexShrink: 0 },
  resultatBarWrap: { flex: 1, height: 5, background: '#f0f0f0', borderRadius: 99 },
  resultatBar: { height: 5, borderRadius: 99 },
  visiteCard: { background: '#fff', borderRadius: 10, padding: '12px', display: 'flex', gap: 10, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' },
  visiteDateBadge: { fontSize: 11, color: '#888', minWidth: 60, flexShrink: 0, paddingTop: 2 },
  visiteClient: { fontSize: 13, fontWeight: 600, color: '#1C2833' },
  visiteResultat: { fontSize: 12, color: '#666', marginTop: 2 },
  visiteComment: { fontSize: 11, color: '#888', marginTop: 4, fontStyle: 'italic' },
  clientCard: { background: '#fff', borderRadius: 10, padding: '12px', display: 'flex', alignItems: 'center', gap: 10, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' },
  clientAv: { width: 34, height: 34, borderRadius: '50%', background: '#E6F1FB', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 600, color: '#185FA5', flexShrink: 0 },
  clientNom: { fontSize: 13, fontWeight: 600, color: '#1C2833' },
  clientSub: { fontSize: 11, color: '#888', marginTop: 2 },
  potBadge: { fontSize: 10, padding: '2px 8px', borderRadius: 99, fontWeight: 500, flexShrink: 0 },
  actionCard: { borderRadius: 10, padding: '12px', display: 'flex', gap: 10, alignItems: 'center', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' },
  primeCard: { background: '#1C2833', borderRadius: 12, padding: '20px', textAlign: 'center' },
  primeTitre: { fontSize: 13, color: 'rgba(255,255,255,0.7)', marginBottom: 8 },
  primeMontant: { fontSize: 32, fontWeight: 700, color: '#fff', marginBottom: 6 },
  primeBase: { fontSize: 12, color: 'rgba(255,255,255,0.6)', marginBottom: 12 },
  primeBar: { height: 6, background: 'rgba(255,255,255,0.2)', borderRadius: 99 },
  primeBarFill: { height: 6, background: '#3B6D11', borderRadius: 99 },
  objRow: { background: '#fff', borderRadius: 10, padding: '12px', display: 'flex', alignItems: 'center', gap: 10, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' },
  objDot: { width: 10, height: 10, borderRadius: '50%', flexShrink: 0 },
  empty: { textAlign: 'center', padding: '2rem', color: '#888', display: 'flex', flexDirection: 'column', alignItems: 'center' },
  editCard: { background: '#fff', borderRadius: 10, padding: '14px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' },
  fieldLabel: { fontSize: 12, color: '#666', marginBottom: 4 },
  input: { width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, fontFamily: 'system-ui' },
  btnCancel: { flex: 1, padding: 11, border: '1px solid #ddd', borderRadius: 10, background: '#fff', color: '#666', fontSize: 13, cursor: 'pointer' },
  btnSave: { flex: 2, padding: 11, background: '#1C2833', border: 'none', borderRadius: 10, color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer' },
};
